export default __webpack_public_path__ + "static/media/gray_filled_man.e7e65d82.svg";